module.exports = "/images/mobile-button.svg?f8d3e663d9a2742951cc52b947e6a217";